import client from '../client';
import { getResponseValue } from 'util/validate';

export const _verifyRecaptcha = async (params) => {
  const { recaptchaValue } = params;

  const response = await client.post('verify-recaptcha', { recaptchaValue }, { credentials: 'omit' });

  return await getResponseValue(response);
};
